module.exports = __webpack_public_path__ + "static/img/no_data.cbb0ea55.svg";